<div class="ng6-input-error">
  <a360-icon
    icon="exclamation-circle"
    [color]="!isBlue ? iconColors.RED : iconColors.BLUE"
    [width]="iconSizes.XS"
    [height]="iconSizes.XS"
  ></a360-icon>
  <div [attr.role]="announceError > 0 ? 'alert' : null" aria-live="assertive" [attr.announce-error]="announceError">
    <ng-content></ng-content>
  </div>
</div>
